import BasePage from "pages/base_page"

export default class PartnerPage extends BasePage {
  initialize(options) {
    super.initialize(options)
  }
}
